import classNames from "classnames";

export default function Item1({ it, formatDate, handleNewsDetail }: any) {
  return (
    <div className="flex justify-start items-center gap-x-16 mb-10 px-16" onClick={() => handleNewsDetail(it.id)}>
      <img className="w-90 h-90 rounded-10 shrink-0" src={it.image} alt="" />
      <div className={classNames(["flex flex-col justify-between h-90 font-[Roboto,Roboto]"])}>
        <p className="text-ellipsis-4 font-500 text-12 color-[var(--app-text-06)] flex justify-start">{it.title}</p>

        <p className="font-400 text-10 color-[var(--app-text-05)] flex justify-start">
          <i>{formatDate(it.addtime)}</i>
          <i className="font-900"> · </i>
          <i>{it.media}</i>
        </p>
      </div>
    </div>
  );
}
